<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">
          <div class="row">
            <div class="col-sm-12 col-md-4">
                <div class="card border-0">
                  <div class="card-header font-weight-bold bg-transparent border-0">{{ detailsList.name }}</div>
                  <div class="card-body">

                    <div class="row mb-3">
                      <div class="col-12">
                        <a href="#" @click="changeRightView('item-details', '','','')">Details</a>
                        <span class="mx-2">|</span>
                        <a href="#" @click="changeRightView('item-products', '','','')">Products</a>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-12">
                        <small class="text-muted">Full Name</small>
                      </div>
                      <div class="col-12">
                        {{ detailsList.desc_name }}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <small class="text-muted">Part Number</small>
                      </div>
                      <div class="col-12">
                        {{ detailsList.part_number }}
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <small class="text-muted">Description</small>
                      </div>
                      <div class="col-12">
                        {{ detailsList.description }}
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-8">
              <transition name="slide-fade" mode="out-in">
                <component 
                  :is="rightView" 
                  :prop1="prop1" 
                  :prop2="prop2" 
                  :prop3="prop3" 
                  @onSComplete="successComplete" 
                  @onUComplete="unsuccessComplete"
                >
                </component>
              </transition>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>

<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<script>
import {store} from '../../stores/admin-item-single-main-store.js'

import itemProducts from '../adminItemSingleMainPageComponents/item-products.vue'
import itemDetails from '../adminItemSingleMainPageComponents/item-details.vue'

export default {
  props: ['prod'],
  store,
  data: function () {
    return { 

    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },
    detailsComp () { return this.$store.state.detailsComp },

    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prodID },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllProducts();
    this.getItemDetails();
    this.getAllItemProducts();
    this.getAllItems();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    getAllProducts() { this.$store.dispatch("getAllProducts", { prod: this.prod }) },
    getItemDetails() { this.$store.dispatch("getItemDetails", { prod: this.prod }) },
    getAllItemProducts() { this.$store.dispatch("getAllItemProducts", { prod: this.prod }) },
    getAllItems() { this.$store.dispatch("getAllItems", { prod: this.prod }) },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
    'item-products' : itemProducts,
    'item-details' : itemDetails,
  },
  filters: {

  }
}
</script>
